import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id CD51D79A-B691-4B46-BABF-6A419EE2716A
 * name alpha-e-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-e-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphaECircleOutlineIcon = createSvgIcon(<><path d="M9,7H15V9H11V11H15V13H11V15H15V17H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" /></>, 'AlphaECircleOutlineIcon');
export default AlphaECircleOutlineIcon